// eslint-disable-next-line no-unused-vars
import React from 'react';
import { object } from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Copy, Package } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import Img from 'Containers/Image/Image';
import useToastNotifications from 'Hooks/useToastNotifications';
import copyToClipboard from 'Utils/copyToClipboard';

const Preview = styled.div`
  align-items: center;
  border-bottom: 1px solid ${ props => props.theme.products.colors.border };
  display: flex;
  gap: 0.75rem;
  padding-bottom: 0.875rem;

  .thumb {
    align-items: center;
    display: flex;
    flex: 0 0 64px;
    height: 64px;
    justify-content: center;

    .image {
      max-height: 100%;
      max-width: 100%;
    }
  }

  .description {
    display: -webkit-box;
    font-weight: 600;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .code {
    color: ${ props => props.theme.colors.gray };
    font-size: 0.75rem;
    margin-top: 0.25rem;

    button {
      background: none;
      border: 0;
      color: ${ props => props.theme.colors.altOrange };
      cursor: pointer;
      padding: 0 0.25rem;
      vertical-align: middle;
    }
  }
`;

const ProductPreview = ({ product }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const toast = useToastNotifications();

  const handleCopy = async () => {
    if (await copyToClipboard(product?.code || '')) {
      toast.addNotification({
        type: 'success',
        title: t('products.copyCodeSuccess')
      });
    }
  };

  return (
    <Preview theme={ theme }>
      <div className="thumb">
        <Img
          className="image"
          src={ [product?.picture, product?.pictures?.at(0)?.urlThumbnailPicture] }
          unloader={ <Package size={ 36 } strokeWidth={ 1.25 } /> }
          alt={ product?.name || '' }
        />
      </div>
      <div>
        <p className="description">{ product?.description || product?.title || product?.name }</p>
        <p className="code">
          { t('products.code') }: { product?.code }
          <button type="button" onClick={ handleCopy } aria-label={ t('products.copyCodeSuccess') }>
            <Copy size={ 15 } />
          </button>
        </p>
      </div>
    </Preview>
  );
};

ProductPreview.propTypes = {
  product: object
};

export default ProductPreview;
